import { ExportProperty } from '@bindoc-projects/util-domain-lib';
import { BdExportColumnOption } from '../template-controls/export-column-option';

/**
 * Adapts the virtual-clinic property tree (`ExportProperty`) to the generic
 * {@link BdExportColumnOption} consumed by the shared export-template form.
 * Only `specific` properties are selectable columns; `root`/`group` nodes group
 * them. Uses the German display name (the app is single-locale here).
 */
export function toCaseExportColumnOptions(
  properties: ExportProperty[],
): BdExportColumnOption[] {
  return properties.map((property) => ({
    id: property.property.id,
    displayName: property.property.displayName['de'],
    selectable: property.property.type === 'specific',
    children: toCaseExportColumnOptions(property.children ?? []),
  }));
}
